export const getTimeDifference = (
  futureDateObj: Date,
  dateToSubtractObj: Date,
) => futureDateObj.getTime() - dateToSubtractObj.getTime();
